import React from 'react';

const Modal = ({ show, title, children, onClose }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 transition-opacity duration-300">
      <div className="bg-backgroundDark border border-white/10 rounded-lg shadow-lg max-w-3xl w-full p-6 sm:p-8 m-4 relative transform transition-transform duration-300 scale-100">
        <div className="flex justify-between items-center mb-4 sticky top-0 bg-backgroundDark z-10 py-2 -mt-2">
          <h2 className="text-xl font-bold text-white">{title}</h2>
          <button
            onClick={onClose}
            className="text-white/70 hover:text-white focus:outline-none p-2 rounded-full hover:bg-white/10"
          >
            &times;
          </button>
        </div>
        <div className="text-white/80 max-h-[calc(90vh-100px)] overflow-y-auto -mx-2 px-2">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
